/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* leveranciers.module.ts
* 9-3-2023 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Leverancierlijstscherm} from './leverancierlijst';
import {NgModule} from '@angular/core';
import {SihwDatatableModule} from 'sihw-ng/datatable/datatable.module';
import {CommonModule} from '@angular/common';

const schermen = [
  Leverancierlijstscherm
];

@NgModule({
  declarations: schermen,
  imports: [
    CommonModule,
    SihwDatatableModule
  ],
  providers: [],
  exports: schermen
}) export class LeveranciersModule{}

Leverancierlijstscherm.register('Leverancierlijstscherm');
